<nz-tabset nzSize="small" nzTabPosition="top" [(nzSelectedIndex)]="communicationIndex" [nzType]="button.onClickComposeAdditionalCommunication ? 'editable-card' : 'card'" (nzAdd)="addAdditional()" (nzClose)="removeAdditional($event)">
	<nz-tab *ngFor="let communication of requiredCommunications" [nzTitle]="title1">
		<ng-template #title1>
			<app-invalid-form-indicator [form]="communication.form"></app-invalid-form-indicator>
			{{getName(communication)!}}
		</ng-template>
	</nz-tab>
	<nz-tab *ngFor="let communication of additionalCommunications" [nzTitle]="title2" nzClosable>
		<ng-template #title2>
			<app-invalid-form-indicator [form]="communication.form"></app-invalid-form-indicator>
			{{getName(communication)!}}
		</ng-template>
	</nz-tab>
</nz-tabset>
<nz-empty *ngIf="selectedCommunication == null"></nz-empty>

<ng-container *ngIf="selectedCommunication != null">
	<div class="row mb-3">
		<div class="col">
			<nz-switch
				class="float-end"
				[ngModel]="mode == 'Preview'"
				(ngModelChange)="mode = $event ? 'Preview' : 'Compose'; buildPreview()"
				nzCheckedChildren="Preview"
				nzUnCheckedChildren="Compose">
			</nz-switch>
		</div>
	</div>
	<!-- Compose content -->
	<app-compose-notification *ngIf="mode == 'Compose'" [input]="selectedCommunication" [placeholders]="step.placeholders" [showActions]="false"></app-compose-notification>
</ng-container>
<!-- Preview content -->
<ng-container *ngIf="mode == 'Preview'">
	<nz-form-item>
		<nz-form-label [nzSpan]="2">From</nz-form-label>
		<nz-form-control [nzSpan]="22">
			<input nz-input readonly [value]="previewCommunication.emailFrom" />
		</nz-form-control>
	</nz-form-item>
	<!-- Email fields -->
	<ng-container *ngIf="previewCommunication.type == 'Email'">
		<nz-form-item>
			<nz-form-label [nzSpan]="2">To</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input readonly [value]="previewCommunication.emailTo">
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2">Cc</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input readonly [value]="previewCommunication.emailCc" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2">Bcc</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input readonly [value]="previewCommunication.emailBcc" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>Subject</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input readonly [value]="previewCommunication.emailSubject" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<textarea  rows="{{previewCommunication.emailBody?.split('\n')?.length??5}}"  nz-input readonly [value]="previewCommunication.emailBody"></textarea>
			</nz-form-control>
		</nz-form-item>
	</ng-container>
	<!-- SMS fields -->
	<ng-container *ngIf="previewCommunication.type == 'Sms'">
		<nz-form-item>
			<nz-form-label [nzSpan]="2">To</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input readonly [value]="previewCommunication.smsMsisdn" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<textarea rows="{{previewCommunication.smsMessage?.split('\n')?.length??5}}" nz-input readonly [value]="previewCommunication.smsMessage"></textarea>
			</nz-form-control>
		</nz-form-item>
	</ng-container>

	<nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" /> Selected |
	<nz-icon nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff2f96" /> Not Selected
	<nz-table [nzData]="previewCommunication.attachments??[]" [nzShowPagination]="false" [nzSize]="'small'">
		<thead>
			<tr>
				<th>Attachment</th>
				<th>Download Preview</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let attachment of previewCommunication.attachments">
				<td *ngIf="attachment.name != 'file'">
					<nz-icon *ngIf="attachment.selected == true"  nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" />
					<nz-icon *ngIf="attachment.selected == false" nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff2f96" />
					{{attachment.name}}
				</td>
				<td *ngIf="attachment.name == 'file'">
					<nz-icon *ngIf="attachment.selected == true"  nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" />
					<nz-icon *ngIf="attachment.selected == false" nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff2f96" />
					{{attachment.fileName}}
				</td>

				<td>
					<button *ngIf="!isAttachmentDownloading(attachment)" (click)="downloadPreview(attachment)" nz-button nzType="dashed" >Download Preview</button>
					<button *ngIf="isAttachmentDownloading(attachment)" nz-button nzType="dashed" >Downloading...</button>
				</td>
			</tr>
		</tbody>
	</nz-table>
</ng-container>
<div class="row mb-3">
	<div class="col">
		<hr>
		<div class="compose-notification-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
			<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
			<button nz-button nzType="primary" [disabled]="!isValid()" (click)="onSend()" *ngIf="selectedCommunication == null">Submit</button>
			<button nz-button nzType="primary" [disabled]="!isValid()" (click)="onSend()" *ngIf="selectedCommunication != null">Send</button>
		</div>
	</div>
</div>


<nz-modal
    [(nzVisible)]="isPdfModalVisible"
    [nzTitle]="pdfPreviewFilename"
    [nzWidth]="'80vw'"
    [nzFooter]="pdfModalFooter"
    (nzOnCancel)="closePdfModal()"
    [nzBodyStyle]="{ height: '80vh', padding: '0' }">
    <ng-container *nzModalContent>
        <iframe
			*ngIf="pdfPreviewUrl"
			style="width: 100%; height: 100%; border: none;"
		    [src]="pdfPreviewUrl"></iframe>
    </ng-container>
</nz-modal>

<ng-template #pdfModalFooter>
    <button nz-button nzType="default" (click)="closePdfModal()">Close</button>
</ng-template>
